import Navbar from "../DashboardNavbar";
import GSTPortalSidebar from "../GstportalSideBar";


const Layout = ({ children }) => {

  return (
    <>
      <div className="layout">
        <div className="container-fluid m-0 g-0 p-0 sticky top-0 z-50">
          <div className="navbarStyle ">
            <Navbar />
          </div>

          <div className="otherPage">
            <div>
              <GSTPortalSidebar/>
            </div>
            <div className="pages">{children}</div>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;